import {ChangeDetectionStrategy, Component, computed, inject, input, OnInit, output} from '@angular/core';
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../../types/product-card-files.types";
import {AttachFileParams} from "../../../../../../../../core/types/file.types";
import {TpTurnkeyCostPathStateService} from "../../services/tp-turnkey-cost-path-state.service";
import {TurnkeyCostFile} from "../../types/turnkey-cost-file.types";
import {TpTurnkeyCostService} from "../../services/tp-turnkey-cost.service";
import {TurnkeyCostFilesStateService} from "../../services/turnkey-cost-files-state.service";

@Component({
  selector: 'div[app-turnkey-cost-files]',
  standalone: true,
  imports: [
    FileCardComponent,
    FileUploadCardComponent
  ],
  templateUrl: './turnkey-cost-files.component.html',
  styleUrl: './turnkey-cost-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TurnkeyCostFilesComponent implements OnInit {
  turnkeyCostId = input.required<number>();
  turnkeyCostKey = input.required<string>();
  isEditModeActive = input<boolean>(false);
  setLoadingState = output<boolean>();

  private tpTurnkeyCostPathStateService: TpTurnkeyCostPathStateService = inject(TpTurnkeyCostPathStateService);
  private tpTurnkeyCostService: TpTurnkeyCostService = inject(TpTurnkeyCostService);
  private turnkeyCostFilesStateService: TurnkeyCostFilesStateService = inject(TurnkeyCostFilesStateService);

  public turnkeyCostFileType = computed(() => this.tpTurnkeyCostPathStateService.fileTypeState());

  public async ngOnInit(): Promise<void> {
    await this.getFiles();
  }

  public getFilesById(): Array<TurnkeyCostFile> {
    return this.turnkeyCostFilesStateService.getTurnkeyCostFilesById(this.turnkeyCostId());
  }

  public async handleDelete(isImage: boolean, file: TurnkeyCostFile):  Promise<void> {
    const deleteFileParams: DeleteFileParams = {
      path: this.tpTurnkeyCostPathStateService.pathFileState(),
      id: file.id
    };

    this.tpTurnkeyCostService.deleteFile(deleteFileParams)
      .then(() => this.turnkeyCostFilesStateService.deleteFileById(file.id, this.turnkeyCostId()));
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachFileParams: AttachProductCardFileParams = {
      path: this.tpTurnkeyCostPathStateService.pathFileState(),
      body: {
        fileId: fileId,
        [this.tpTurnkeyCostPathStateService.fileKeyState()]: parentId
      }
    };

    await this.tpTurnkeyCostService.attachFile<TurnkeyCostFile>(attachFileParams)
      .then((data) => this.turnkeyCostFilesStateService.updateTurnkeyCostFilesState(this.turnkeyCostId(), data));
  }

  private async getFiles(): Promise<void> {
    this.setLoadingState.emit(true);
    const params: GetFilesParams = {
      path: this.tpTurnkeyCostPathStateService.pathFileState(),
      params: { [this.tpTurnkeyCostPathStateService.fileKeyState()]: this.turnkeyCostId() }
    };

    await this.tpTurnkeyCostService.getFiles(params)
      .then((data) => this.turnkeyCostFilesStateService.setTurnkeyCostFilesState(this.turnkeyCostId(), data))
      .finally(() => this.setLoadingState.emit(false));
  }
}
